//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cardMakeSendEmail, getUpdateInfo } from '@/views/salesCardManagement/api';
export default {
  name: 'sendSupplierDialog',
  data: function data() {
    return {
      sendSupplierDialog: false,
      submitLoading: false,
      ruleForm: {},
      id: '',
      has_wx_account: '',
      yl88: [],
      makeList: []
    };
  },
  methods: {
    send: function send() {
      var _this = this;
      var params = {
        id: this.id,
        has_wx_account: this.has_wx_account,
        yl88: this.yl88
      };
      cardMakeSendEmail(params).then(function () {
        _this.$message.success('发送成功');
        _this.$emit('sendSuccess');
        _this.handleClose();
      });
    },
    getCardMakeInfo: function getCardMakeInfo() {
      var _this2 = this;
      var params = {
        id: this.id,
        has_wx_account: this.has_wx_account
      };
      getUpdateInfo(params).then(function (res) {
        _this2.ruleForm = res.data;
      });
    },
    handleClose: function handleClose() {
      this.sendSupplierDialog = false;
    }
  }
};